import Vue from 'vue';
const {
  $gettext
} = Vue.prototype;
export default {
  defaultEntity: {
    type: 2,
    youtubes: [],

    directorName: '',
    directorPosition: '',
    question1: '',
    question2: '',
    question3: '',
    question4: '',
    question5: '',
    question6: '',
    question7: '',
  },
  layout(entity, states, cities) {
    const {
      getters,
      state
    } = Vue.prototype.store;
    const {
      rules
    } = state.toggle;
    const {
      countryList
    } = state.location;
    return [{
        isTwoColum: true,
        fieldName: 'website',
        label: $gettext('Website'),
      },
      {
        isTwoColum: true,
        fieldName: 'phone',
        label: $gettext('Phone'),
      },
      {
        type: 'divider',
      },
      {
        isTwoColum: true,
        fieldName: 'facebookUrl',
        label: $gettext('Facebook'),
      },
      // {
      //   isTwoColum: true,
      //   fieldName: 'linkedinUrl',
      //   label: $gettext('Linkedin'),
      // },
      {
        isTwoColum: true,
        fieldName: 'youtubeUrl',
        label: $gettext('Youtube'),
      },
      {
        isTwoColum: true,
        fieldName: 'twitterUrl',
        label: $gettext('Twitter'),
      },
      {
        isTwoColum: true,
        fieldName: 'instagramUrl',
        label: $gettext('Instagram'),
      },
      {
        isTwoColum: true,
        fieldName: 'tripadvisorUrl',
        label: $gettext('Tripadvisor'),
      }
    ];
  }
};